import { useEffect, useState } from 'react';

const DEFAULT_INTERVAL_MS = 60_000;

// Refreshes "now" on an interval so a site's open/closed status flips without a server
// round-trip or a screen remount, per the design's "refreshed periodically" requirement.
// eslint-disable-next-line import/prefer-default-export -- named export matches every sibling hook in this directory (useSite, useSitesWithinRadius, useResolvedUserLocation); this file just has no companion result-type export to make ESLint recognize the pattern.
export function useNow(intervalMs: number = DEFAULT_INTERVAL_MS): Date {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);

  return now;
}
